import { Slide, ToastContainer } from 'react-toastify'

const AppToastContainer = () => {
  return (
    <ToastContainer
      autoClose={6000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      pauseOnHover
      pauseOnFocusLoss
      position="top-right"
      theme="colored"
      transition={Slide}
      draggable
      limit={5}
    />
  )
}

export default AppToastContainer
